/**
 * AI 补位建议卡片（F2 浅层「AI 队友」）。
 *
 * 口径纪律：
 * - 明确标注「AI 建议画像」，绝不与真实候选人混排，绝不出现"匹配准确率/概率"字样；
 * - 数据全部来自后端 aiSuggestions（shared 纯函数生成，前端不做任何计算）；
 * - 虚线边框 + 专属样式与真实结果卡（result-card）视觉区分。
 */

import type { AiSuggestion } from '@crossmatch/shared';

import { schoolLabel, skillLabel } from '../lib/format.js';
import { Tag } from './Tag.js';

export interface AiSuggestCardProps {
  suggestion: AiSuggestion;
}

export function AiSuggestCard({ suggestion }: AiSuggestCardProps) {
  return (
    <article className="card ai-suggest-card">
      <div className="result-head">
        <div className="grow">
          <div className="result-name">{suggestion.name}</div>
          <div className="row-tight">
            <Tag tone="school">{schoolLabel(suggestion.school)}</Tag>
            <Tag tone="primary" title="由匹配需求反推生成的招募建议，不是真实候选人">
              AI 建议画像
            </Tag>
          </div>
        </div>
      </div>

      {suggestion.headline !== undefined ? <p className="chart-note">{suggestion.headline}</p> : null}

      <div className="row-tight">
        {suggestion.skills.map((skill) => (
          <Tag key={skill} tone="default">
            {skillLabel(skill)}
          </Tag>
        ))}
      </div>

      <p className="ai-suggest-tip">
        获取建议：到{schoolLabel(suggestion.school)}的院系群 / 竞赛群，寻找具备上述能力的队友加入候选人池。
      </p>
    </article>
  );
}
